import { ReferenceManyField } from 'react-admin';

import { GetB2bCampaignsPayoutsOneResponse } from '@Common/types/b2b/campaigns';

import { b2bPayoutsStatusChoices } from '@sh4res/bo-common/choices/payouts';
import { DatagridTyped, Pagination } from '@sh4res/bo-common/components';
import { CurrencyField, IdField, SelectChipField } from '@sh4res/bo-common/fields';
import { ResourceBasePath } from '@sh4res/bo-common/hooks';
import { ColumnList } from '@sh4res/bo-common/utils';

type PayoutItem = Pick<
  GetB2bCampaignsPayoutsOneResponse,
  'id' | 'total_gross_amount' | 'user_currency_amount' | 'tax_amount' | 'status'
>;

const displayedColumns: (keyof PayoutItem)[] = [
  'id',
  'total_gross_amount',
  'user_currency_amount',
  'tax_amount',
  'status',
];

export const CampaignsPayoutsList = ({
  resourceBasePath,
}: {
  resourceBasePath: ResourceBasePath;
}) => {
  const columnRegistry: ColumnList<PayoutItem> = {
    id: (
      <IdField
        reference={`${resourceBasePath}campaigns/payouts`}
        label="resources.bo_common.b2b.savings_funds_requests.payouts.fields.id"
        data-testid="BoExternalCampaignsPayoutsList_IdField"
      />
    ),
    user_currency_amount: (
      <CurrencyField
        currency="user_currency"
        label="resources.bo_common.b2b.savings_funds_requests.payouts.fields.user_currency_amount"
        testId="BoExternalCampaignsPayoutsList_UserCurrencyAmountField"
      />
    ),
    total_gross_amount: (
      <CurrencyField
        currency="user_currency"
        label="resources.bo_common.b2b.savings_funds_requests.payouts.fields.total_gross_amount"
        testId="BoExternalCampaignsPayoutsList_TotalGrossAmountField"
      />
    ),
    tax_amount: (
      <CurrencyField
        currency="user_currency"
        label="resources.bo_common.b2b.savings_funds_requests.payouts.fields.tax_amount"
        testId="BoExternalCampaignsPayoutsList_TaxAmountField"
      />
    ),
    status: (
      <SelectChipField
        choices={b2bPayoutsStatusChoices}
        label="resources.bo_common.b2b.savings_funds_requests.payouts.fields.status"
        data-testid="BoExternalCampaignsPayoutsList_StatusField"
      />
    ),
  };

  return (
    <ReferenceManyField
      data-testid="BoExternalCampaignsPayoutsList_PayoutsList"
      reference={`${resourceBasePath}campaigns/payouts`}
      target="savings_funds_request_id"
      perPage={10}
      pagination={<Pagination />}>
      <DatagridTyped<PayoutItem>
        rowClick="show"
        sortableColumns={[]}
        columnRegistry={columnRegistry}
        displayedColumns={displayedColumns}
        bulkActionButtons={false}
        showCard={true}
      />
    </ReferenceManyField>
  );
};
